import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mktg',
  templateUrl: './mktg.component.html',
  styleUrls: ['./mktg.component.css']
})
export class MktgComponent implements OnInit {

  videoElement!: HTMLVideoElement;

  constructor() { }

  ngOnInit(): void {
    this.videoElement = document.getElementById('video-element') as HTMLVideoElement;
    this.videoElement.volume = 0;
  }

}
